import { useDispatch, useSelector } from "react-redux"
import {
  deletePost,
  findAllPost,
  getPost,
  savePost,
} from "../store/features/postSlice"
import {
  Alert,
  Backdrop,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material"
import { useEffect, useState } from "react"
import { Template } from "../components/Template"
import { getAux } from "../store/features/auxSlice"
import { MyTable } from "../components/MyTable"
import { MyModal } from "../components/MyModal"
import AddIcon from "@mui/icons-material/Add"
import moment from "moment"
import { findAllUser, getUser } from "../store/features/userSlice"
import "dayjs/locale/es"
import { POST_MODEL } from "../constants"
import QueryStatsIcon from "@mui/icons-material/QueryStats"
import TuneIcon from "@mui/icons-material/Tune"
import { IphonePreview } from "../components/IphonePreview"
import { ScopeLimitedToInput } from "../components/inputs/ScopeLimitedToInput"
import { MyDateInput } from "../components/inputs/MyDateInput"
import { InteractionsForDayChart } from "../components/charts/post/InteractionsForDayChart"
import { InteractionsForPostForDayChart } from "../components/charts/post/InteractionsForPostForDayChart"
import { MyImagePickerInput } from "../components/inputs/MyImagePickerInput"
import { getAuth } from "../store/features/authSlice"

moment.locale("es")
const { REACT_APP_STATIC_ROUTE: STATIC_ROUTE } = process.env

export const PostsScreen = () => {
  const aux = useSelector(getAux)
  const post = useSelector(getPost)
  const user = useSelector(getUser)
  const auth = useSelector(getAuth)
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [selected, setSelected] = useState({ ...POST_MODEL })
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenStats, setIsOpenStats] = useState(false)
  const [filters, setFilters] = useState({
    postType: 1,
    title: "",
    user: "",
    state: 1,
  })

  useEffect(() => {
    dispatch(
      findAllUser({
        start: 0,
        limit: 500,
        role: 3,
        personType: 2,
        state: 1,
        jwt: auth.data.jwtToken,
      })
    )
  }, [])

  useEffect(() => {
    if (!!selected) {
      console.log(selected)
    }
  }, [selected])

  useEffect(() => {
    setPage(0)
    getAll()
  }, [filters])

  useEffect(() => {
    getAll()
  }, [page, rowsPerPage])

  const getAll = () => {
    dispatch(
      findAllPost({
        start: page,
        limit: rowsPerPage,
        postType: filters.postType,
        title: filters.title,
        state: filters.state,
        jwt: auth.data.jwtToken,
      })
    )
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const selectItem = (row) => {
    setSelected(row)
    setIsOpen(true)
  }

  const selectItemStats = (row) => {
    setSelected(row)
    setIsOpenStats(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    setSelected({ ...POST_MODEL })
  }

  const handleCloseStats = () => {
    setIsOpenStats(false)
    setSelected({ ...POST_MODEL })
  }

  const handleChangeFilter = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value })
  }

  const handleClickNewItem = () => {
    setSelected({ ...POST_MODEL })
    setIsOpen(true)
  }

  const onSave = () => {
    dispatch(savePost({ post: selected, jwt: auth.data.jwtToken }))
  }

  const onDelete = () => {
    dispatch(deletePost({ id: selected.id, jwt: auth.data.jwtToken }))
  }

  const handleChangeElement = (e) => {
    const name = e.target.name
    const value = e.target.value

    console.log(name, value)

    switch (name) {
      case "scope":
        setSelected({ ...selected, [name]: value, scopeLimitedTo: "" })
        break
      case "scopeLimitedTo":
        setSelected({ ...selected, [name]: value.join(";") })
        break
      default:
        setSelected({ ...selected, [name]: value })
        break
    }
  }

  const columns = [
    {
      field: "cover",
      headerName: "Portada",
      width: 100,
      align: "left",
      render: (params) => (
        <img
          src={STATIC_ROUTE + params.row.cover}
          width={"80%"}
          style={{ borderRadius: 10 }}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null // prevents looping
            currentTarget.src = "/no-image-available.png"
          }}
        />
      ),
    },
    { field: "title", headerName: "Título", width: 300, align: "left" },
    { field: "user", headerName: "Usuario", width: 150, align: "left" },
    {
      field: "likes",
      headerName: "Likes",
      width: 100,
      align: "right",
      render: (params) => (
        <span style={{ color: "red" }}>
          {
            post.data
              .find((item) => item.post.id === params.row.id)
              .subscriptions.filter((item) => item.subscriptionMode === 2)
              .length
          }
        </span>
      ),
    },
    {
      field: "saved",
      headerName: "Guardados",
      width: 100,
      align: "right",
      render: (params) => (
        <span style={{ color: "orange" }}>
          {
            post.data
              .find((item) => item.post.id === params.row.id)
              .subscriptions.filter((item) => item.subscriptionMode === 1)
              .length
          }
        </span>
      ),
    },
    {
      field: "insertionDate",
      headerName: "Fecha de publicación",
      width: 200,
      align: "left",
      render: (params) => (
        <span>
          {moment(params.row.insertionDate).format("YYYY-MM-DD, hh:mm:ss a")}
        </span>
      ),
    },
    {
      field: "",
      headerName: "Acciones",
      width: 100,
      align: "center",
      render: (params) => (
        <Grid container spacing={2} pt={1}>
          <IconButton
            sx={{ cursor: "pointer" }}
            onClick={() => selectItem(params.row)}
          >
            <TuneIcon />
          </IconButton>
          <IconButton
            sx={{ cursor: "pointer" }}
            onClick={() => selectItemStats(params.row)}
          >
            <QueryStatsIcon />
          </IconButton>
        </Grid>
      ),
    },
  ]

  const modal = () => {
    return (
      <MyModal
        updateTitle={
          <span>
            <span>Editar </span>
            <span style={{ color: "tan" }}>
              {
                aux.data.postTypes.find((item) => item.id === selected.postType)
                  .value
              }
              :{" "}
            </span>
            <span style={{ color: "gray" }}>{selected.title}</span>
          </span>
        }
        insertTitle="Redactar nuevo post"
        isOpen={isOpen}
        handleClose={handleClose}
        selected={selected}
        onSave={onSave}
        onDelete={onDelete}
      >
        <Grid container spacing={2}>
          <Grid item xs={7}>
            <Grid container spacing={2}>
              <Grid item xs={12} my={2}>
                <Divider>
                  <Chip label="Datos básicos" />
                </Divider>
              </Grid>
              {!selected.id && (
                <>
                  {aux.data.postTypes.some(
                    (pt) => pt.id === selected.postType
                  ) && (
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Tipo de post</InputLabel>
                        <Select
                          value={selected.postType}
                          label="Tipo de post"
                          name="postType"
                          onChange={handleChangeElement}
                        >
                          {aux.data.postTypes.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                </>
              )}
              {[1, 2, 3, 4].some((pt) => pt === selected.postType) && (
                <Grid item xs={12}>
                  <TextField
                    label="Copy"
                    variant="outlined"
                    fullWidth
                    name="copy"
                    value={selected.copy}
                    onChange={handleChangeElement}
                    inputProps={{ maxLength: 200 }}
                  />
                </Grid>
              )}
              {[1, 2, 3, 4, 5].some((pt) => pt === selected.postType) && (
                <Grid item xs={12}>
                  <TextField
                    label="Título"
                    variant="outlined"
                    fullWidth
                    name="title"
                    value={selected.title}
                    onChange={handleChangeElement}
                    inputProps={{ maxLength: 50 }}
                  />
                </Grid>
              )}
              {[1, 2, 3, 4].some((pt) => pt === selected.postType) && (
                <Grid item xs={12}>
                  <TextField
                    multiline
                    label="Resumen"
                    variant="outlined"
                    fullWidth
                    name="description"
                    value={selected.description}
                    onChange={handleChangeElement}
                    inputProps={{ maxLength: 200 }}
                  />
                </Grid>
              )}
              {[1, 2, 3, 4, 5].some((pt) => pt === selected.postType) && (
                <Grid item xs={12}>
                  <TextField
                    multiline
                    label="Contenido"
                    variant="outlined"
                    fullWidth
                    name="content"
                    value={selected.content}
                    onChange={handleChangeElement}
                    inputProps={{ maxLength: 10000 }}
                  />
                </Grid>
              )}
              {[3].some((pt) => pt === selected.postType) && (
                <Grid item xs={12}>
                  <TextField
                    label="Tópico"
                    variant="outlined"
                    fullWidth
                    name="topic"
                    value={selected.topic}
                    onChange={handleChangeElement}
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>
              )}
              {[1, 2, 3, 4].some((pt) => pt === selected.postType) && (
                <Grid item xs={12}>
                  <TextField
                    label="Enlace externo"
                    variant="outlined"
                    fullWidth
                    name="link"
                    value={selected.link}
                    onChange={handleChangeElement}
                    inputProps={{ maxLength: 200 }}
                  />
                </Grid>
              )}
              {[1, 2, 3, 4, 5].some((pt) => pt === selected.postType) && (
                <>
                  {user.status === "succeeded" && (
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Autor</InputLabel>
                        <Select
                          value={selected.user}
                          label="Autor"
                          name="user"
                          onChange={handleChangeElement}
                        >
                          {user.data
                            .filter((item) => item.role === 3)
                            .map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.businessName}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                </>
              )}
              {[1, 2, 3, 4, 5].some((pt) => pt === selected.postType) && (
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Estado</InputLabel>
                    <Select
                      value={selected.state}
                      label="Estado"
                      name="state"
                      onChange={handleChangeElement}
                    >
                      {aux.data.states.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {[1, 2, 3, 4, 5].some((pt) => pt === selected.postType) && (
                <Grid item xs={6}>
                  <MyImagePickerInput
                    label="Portada"
                    name="cover"
                    value={selected.cover}
                    onChange={handleChangeElement}
                    accept={"image/*"}
                  />
                </Grid>
              )}
              <Grid item xs={12} my={2}>
                <Divider>
                  <Chip label="Monetización" />
                </Divider>
              </Grid>
              {[1].some((pt) => pt === selected.postType) && (
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Moneda</InputLabel>
                    <Select
                      value={selected.coin}
                      label="Moneda"
                      name="coin"
                      onChange={handleChangeElement}
                    >
                      {aux.data.coins.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {[1].some((pt) => pt === selected.postType) && (
                <Grid item xs={6}>
                  <TextField
                    type="number"
                    label="Precio"
                    variant="outlined"
                    fullWidth
                    name="price"
                    value={selected.price}
                    onChange={handleChangeElement}
                    inputProps={{ min: 0 }}
                  />
                </Grid>
              )}
              <Grid item xs={12} my={2}>
                <Divider>
                  <Chip label="Segmentación" />
                </Divider>
              </Grid>
              {[1, 2, 3, 4, 5].some((pt) => pt === selected.postType) && (
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Alcance</InputLabel>
                    <Select
                      value={selected.scope}
                      label="Alcance"
                      name="scope"
                      onChange={handleChangeElement}
                    >
                      {aux.data.scopes.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {[1, 2, 3, 4, 5].some((pt) => pt === selected.postType) && (
                <>
                  {selected.scope !== 1 && (
                    <ScopeLimitedToInput
                      scope={selected.scope}
                      scopeLimitedTo={selected.scopeLimitedTo}
                      handleChangeElement={handleChangeElement}
                    />
                  )}
                </>
              )}
              <Grid item xs={12} my={2}>
                <Divider>
                  <Chip label="Fechas" />
                </Divider>
              </Grid>
              {[1].some((pt) => pt === selected.postType) && (
                <Grid item xs={6}>
                  <MyDateInput
                    label="Inicio"
                    name="startDate"
                    date={selected.startDate}
                    handleChangeElement={handleChangeElement}
                  />
                </Grid>
              )}
              {[1, 2].some((pt) => pt === selected.postType) && (
                <Grid item xs={6}>
                  <MyDateInput
                    label="Finalización"
                    name="finishDate"
                    date={selected.finishDate}
                    handleChangeElement={handleChangeElement}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid
            item
            xs={5}
            sx={{
              position: "fixed",
              right: 60,
            }}
            width={520}
            height={640}
            bgcolor={"#f5f5f5"}
            overflow="hidden"
            display="flex"
            justifyContent="center"
            alignItems="flex-start"
          >
            {selected.postType === 5 && (
              <img
                src="/iphone-bg.jpg"
                alt="..."
                width="85%"
                style={{
                  position: "absolute",
                  paddingRight: 10,
                  paddingTop: 25,
                }}
              />
            )}
            <img
              src={`iphone.png`}
              width={"90%"}
              style={{ position: "absolute", paddingRight: 10 }}
              alt={"..."}
            />
            <IphonePreview element={selected} />
          </Grid>
        </Grid>
      </MyModal>
    )
  }

  const modalStats = () => {
    return (
      <MyModal
        updateTitle={
          <span>
            <span>Estadísticas de </span>
            <span style={{ color: "tan" }}>
              {
                aux.data.postTypes.find((item) => item.id === selected.postType)
                  .value
              }
              :{" "}
            </span>
            <span style={{ color: "gray" }}>{selected.title}</span>
          </span>
        }
        insertTitle=""
        isOpen={isOpenStats}
        handleClose={handleCloseStats}
        selected={selected}
        onSave={onSave}
        onDelete={onDelete}
      >
        {!!selected.id && (
          <InteractionsForPostForDayChart postId={selected.id} />
        )}
      </MyModal>
    )
  }

  return (
    <Template>
      {!!selected && modal()}
      {!!selected && modalStats()}
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <InteractionsForDayChart />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ paddingY: 2 }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={10}>
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Tipo de publicación</InputLabel>
                <Select
                  value={filters.postType}
                  label="Tipo de publicación"
                  name="postType"
                  onChange={handleChangeFilter}
                >
                  {aux.data.postTypes.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                sx={{ marginRight: 1 }}
                label="Título"
                variant="outlined"
                name="title"
                value={filters.title}
                onChange={handleChangeFilter}
              />
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={filters.state}
                  label="Estado"
                  name="state"
                  onChange={handleChangeFilter}
                >
                  {aux.data.states.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <div style={{ marginLeft: 1 }}>
              <IconButton
                size="large"
                color="primary"
                onClick={handleClickNewItem}
              >
                <AddIcon fontSize="large" />
              </IconButton>
            </div>
          </Grid>
          {post.status === "loading" && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={post.status === "loading"}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {post.status === "failed" && (
            <Alert severity="error">{String(post.error)}</Alert>
          )}
          {post.status === "succeeded" && (
            <div style={{ minHeight: 400, width: "100%" }}>
              <MyTable
                columns={columns}
                rows={post.data.map((item) => item.post)}
                page={page}
                handleChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                totalElements={post.totalElements}
              />
            </div>
          )}
        </Paper>
      </Grid>
    </Template>
  )
}
